{
  "appname": "Warm Wishes",
  "deletionAppName": "Warm Wishes App",
  "mail": "{'support@warm-wishes.app'}",
  "getTheApp": "Get the Warm Wishes App!",
  "home-header": "Warm Wishes & More",
  "home-subheader": "Surprise your friends with warm wishes and greeting cards! Send them lovely video greetings, wishes and quotes on pictures and show them how thankful you are!",
  "dataprotection_header_web": "Privacy Policy of Warm Wishes App (Web Version)",
  "dataprotection_header_app": "Privacy Policy of Warm Wishes App",
  "agb_de": "false"
}
